import moment from "moment";
import React, { useCallback, useEffect, useState, } from "react";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import DatePicker from "../../../../components/Input/DatePicker";
import InputSelectAsync from "../../../../components/InputSelectAsync";
import { BrComerceApiService } from "../../../../services/BrComerceApiService";
import { capitalizeFirstLetter } from "../../../../utils/CapitalizeFirstLetter";
import debounce from "../../../../utils/debounce";
import Loading from "../../../home/components/Loading";
import Container from "../../components/Container";
import { definedsDates } from "../Dashboard/partials/Calendar/config";
import { TableOwnDeliveryCounter } from "./components/TableOwnDeliveryCounter";
import styles from "./styles.module.scss";

const OwnDeliveryCounter = () => {

    const api = new BrComerceApiService();

    const [isLoading, setIsLoading] = useState(true);
    const [cities, setCities] = useState(null);
    const [searchClient, setSearchClient] = useState(null);
    const [periodInitialDate, setPeriodInitialDate] = useState(definedsDates.startOfYesterday);
    const [periodFinalDate, setPeriodFinalDate] = useState(definedsDates.endOfToday);

    const handleOnChangeCalendarPeriod = e => {

        if (e?.dateEnd) {

            const inicio = e.dateStart.split("/");
            const fim = e.dateEnd.split("/");

            setPeriodInitialDate(
                new Date(Number(inicio[2]), Number(inicio[1] - 1), Number(inicio[0]))
            );
            setPeriodFinalDate(
                new Date(Number(fim[2]), Number(fim[1] - 1), Number(fim[0]))
            );
        }
    };

    const handleClearPeriodFilter = () => {
        setPeriodInitialDate("");
        setPeriodFinalDate("");
    };

    const getShippings = useCallback(
        debounce(async (initial, final) => {
            try {
                setIsLoading(true);
                const response = await api.makeHttpRequest({
                    method: "GET",
                    url: `/shipping-invoices/list-by-shipping-type`,
                    params: {
                        ...(initial && final && { initialDate: moment(initial, 'DD/MM/YYYY').format("YYYY/MM/DD") }),
                        ...(initial && final && { endDate: moment(final, 'DD/MM/YYYY').format("YYYY/MM/DD") }),
                        ...(searchClient && { subUser: searchClient?.sub }),
                    }
                });

                if (Object.keys(response)?.length) {
                    setCities(response);
                } else {
                    setCities(null);
                }

            } catch (e) {
                console.error(e);
                return Swal.fire({
                    title: "Erro",
                    text: "Não foi possível obter as informações desejadas. Por favor, tente novamente.",
                    icon: "error"
                });
            } finally {
                setIsLoading(false);
            }
        }, 500),
        [periodInitialDate, periodFinalDate, searchClient]);

    useEffect(() => {
        window.setPageTitle("Contador - Super Expresso");
    }, []);

    useEffect(() => {
        getShippings(periodInitialDate, periodFinalDate);
    }, [getShippings, periodInitialDate, periodFinalDate])

    return (
        <>
            <Loading isLoading={isLoading} />
            <Container title="Contador - Super Expresso">
                <div className={styles.filterers}>
                    <div className={styles.row}>
                        <div className={`${styles.formSelect} ${styles.selectPicker}`}>
                            <DatePicker
                                className={"datePickerConfig"}
                                change={handleOnChangeCalendarPeriod}
                                placeholder="Filtrar por expedição"
                                showClearButton={!!periodInitialDate && !!periodFinalDate}
                                onClearFields={handleClearPeriodFilter}
                                range
                                dateStart={definedsDates.startOfYesterday}
                                dateFinal={definedsDates.endOfToday}
                            />
                        </div>
                        <div className={styles.inputClient}>
                            <InputSelectAsync
                                search={searchClient}
                                setSearch={setSearchClient}
                            />
                        </div>
                    </div>
                </div>
                {/* <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                    {
                        !!cities ?
                            (
                                Object.entries(cities)?.map(([key, value]) => {
                                    const arrayLocations = [];
                                    Object.entries(value).forEach(([key, subValue]) => {
                                        if (key !== "location") {
                                            arrayLocations.push({
                                                lat: subValue?.location?.lat,
                                                lng: subValue?.location?.lng
                                            })
                                        }
                                    })

                                    return (
                                        <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                                            <p>{key}</p>
                                            <GoogleMapsReportsOwnDelivery zoom={11} locations={arrayLocations} centralizeCoordinates={value.location} />
                                        </div>
                                    )
                                })
                            ) : (
                                <div className={styles.anErrorOcurred}>
                                    {isLoading ? (
                                        <Spinner animation="border" role="status">
                                            <span style={{ visibility: "hidden" }}>Loading...</span>
                                        </Spinner>
                                    ) : (
                                        <p>Não foram encontrado dados para estes filtro.</p>
                                    )}
                                </div>
                            )
                    }
                </div> */}

                <div className={styles.table}>
                    {!!cities ? (
                        Object.entries(cities)?.map(([key, value]) => {
                            return (
                                <div className={styles.cardInfo}>
                                    <h4>{capitalizeFirstLetter(key)}</h4>
                                    <TableOwnDeliveryCounter setIsLoading={setIsLoading} items={value} />
                                </div>
                            )
                        })
                    ) : (
                        <div className={styles.anErrorOcurred}>
                            {isLoading ? (
                                <Spinner animation="border" role="status">
                                    <span style={{ visibility: "hidden" }}>Loading...</span>
                                </Spinner>
                            ) : (
                                <p>Não foram encontrado dados para estes filtro.</p>
                            )}
                        </div>
                    )}
                </div>
            </Container>
        </>
    )
}

export { OwnDeliveryCounter };